import {ancestorAxis, wikiTab, jobTab} from 'uix/views/utils'

let TranscriptionWikipage = ident => ({
  parts: [
    {
      type: 'TranscriptionWikipage',
      ident: `transcription/${ident}`,
    },
  ],
})

const editor = props => ({
  layout: 'L131Split',
  acl: 'g:transcribeRelease,g:transcribe,g:wiki',
  filters: [ancestorAxis],
  parts: [
    {
      type: 'FulltextEditor',
      bare: true,
      autoEdit: true,
      transcriptionMode: true,
    },
  ],
  ...props,
})

export const xtranscript = {
  cfg: ({dconfig}) => dconfig.transcription.on,
  layout: 'blank',
  tabs: {
    home: {
      default: true,
      ...TranscriptionWikipage('home'),
    },
    specs: TranscriptionWikipage('specs'),
    terms: TranscriptionWikipage('terms'),
    guidelines: TranscriptionWikipage('guidelines'),
    trguidelines: TranscriptionWikipage('trguidelines'),
    // account managment
    resetpw: {parts: []},
    account: {acl: 'g:transcribe,g:transcribeRelease', parts: ['TranscriptionAccount']},
    // registration
    login: {parts: []},
    validatetoken: {parts: []},
    // editor
    wiki: {
      acl: 'g:transcribeRelease,g:transcribe,g:wiki',
      parts: [{type: 'FulltextEditor', autoEdit: true, transcriptionMode: true}],
      filters: [ancestorAxis],
    },
    editor_frame: editor({
      noReloginDialog: true, // is run in iframe
    }),
    // standalone version
    editor: editor(),
    // operator's users-survey
    users: {acl: 'g:transcribeRelease', parts: ['TranscriptionUsers']},
    // user's activity-survey
    activity: {acl: 'g:transcribe', parts: ['TranscriptionActivity']},
    // operator's list for reviewing transcriptions
    review: {
      acl: 'g:transcribeRelease',
      cfg: ({dconfig}) => dconfig.wiki.checkpoints.serveReleased,
      parts: ['TranscriptionReview'],
    },
    published: {acl: 'g:transcribe', parts: ['TranscriptionPublished']},
    begun: {acl: 'g:transcribeRelease', parts: ['TranscriptionBegun']},
  },
}
